import { createContext, useContext, useState } from "react";

interface FilterContextValue {
  page: number;
  setPage: (n: number) => void;
  search: string;
  setSearch: (s: string) => void;
  unreadOnly: boolean;
  setUnreadOnly: (b: boolean) => void;
}

const FilterContext = createContext<FilterContextValue | null>(null);

export function FilterContextProvider({ children }: { children: React.ReactNode }) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [unreadOnly, setUnreadOnly] = useState(false);
  return (
    <FilterContext.Provider value={{ page, setPage, search, setSearch, unreadOnly, setUnreadOnly }}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilterContext = () => {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error("useFilterContext must be inside FilterContextProvider");
  return ctx;
};
